import { trackFbqEvent } from "./fbqEventFactory";
import { gAdsNewsletterConversionEvent } from "./gAdsFactory";
import { trackersFactory } from "./trackersFactory";

const trackers = trackersFactory("footer");

const aboutLink = (): void => trackers({ action: "about-link" });

const becomeCoachLink = (): void => trackers({ action: "become-coach-link" });

const becomeProviderLink = (): void =>
  trackers({ action: "become-provider-link" });

const careersLink = (): void => trackers({ action: "careers-link" });

const chpNoticeLink = (): void => trackers({ action: "chp-notice-link" });

const clinicsLink = (): void => trackers({ action: "clinics-link" });

const facebookLink = (): void => trackers({ action: "facebook-link" });

const faqsLink = (): void => trackers({ action: "faqs-link" });

const howItWorksLink = (): void => trackers({ action: "how-it-works-link" });

const instagramLink = (): void => trackers({ action: "instagram-link" });

const linkedInLink = (): void => trackers({ action: "linkedin-link" });

const mediumLink = (): void => trackers({ action: "medium-link" });

const newsletterForm = (): void => {
  trackers({ action: "newsletter-form" });
  trackFbqEvent("Lead");
  gAdsNewsletterConversionEvent();
};

const philosophyLink = (): void => trackers({ action: "philosophy-link" });

const pricingLink = (): void => trackers({ action: "pricing-link" });

const privacyPolicyLink = (): void =>
  trackers({ action: "privacy-policy-link" });

const termsOfServiceLink = (): void =>
  trackers({ action: "terms-of-service-link" });

const twitterLink = (): void => trackers({ action: "twitter-link" });

export const trackFooter = {
  aboutLink,
  becomeCoachLink,
  becomeProviderLink,
  careersLink,
  chpNoticeLink,
  clinicsLink,
  facebookLink,
  faqsLink,
  howItWorksLink,
  instagramLink,
  linkedInLink,
  mediumLink,
  newsletterForm,
  philosophyLink,
  pricingLink,
  privacyPolicyLink,
  termsOfServiceLink,
  twitterLink,
};
